import { getDate, getMonth, getYear } from 'date-fns';
import React, { useContext, useMemo } from 'react';
import { useModal } from 'src/hooks/useModal';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const ReStockRegisterModal: React.FC = () => {
  const { isVisible, setIsVisible, modalParams } = useModal('reStockRegisterModal');
  const localeResources = useContext(I18nContext);

  const titleWithDate = useMemo(() => {
    const noticeDate = modalParams.extraData?.noticeDate;
    if (noticeDate) {
      const date = new Date(noticeDate);
      const year = getYear(date);
      const month = getMonth(date) + 1;
      const day = getDate(date);
      return localeResources.products.notice.expectedRestockDate(year, month, day);
    }
    return localeResources.products.notice.restockDateUndetermined;
  }, [localeResources.products.notice, modalParams.extraData?.noticeDate]);

  if (!isVisible) return null;

  return (
    <Presenter
      localeResources={localeResources}
      handleClose={() => setIsVisible(false)}
      handleButtonClick={modalParams.function}
      titleWithDate={titleWithDate}
      shouldNotifyArrival={modalParams.extraData?.shouldNotifyArrival}
    />
  );
};
